import React, { useState, useEffect } from "react";
import sendRequest from "../utils/sendRequest";
import validators from "../utils/validators";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import { checkAuth } from "../utils/checkAuth";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import swal from "sweetalert";
import AMCReg from "./AMCReg";
import Rtareg from "./Rtareg";
import Sebi_Registration from "./Sebi_Registration";
import SecureLS from "secure-ls";
import { encrypt } from "../utils/cipher";


// const useStyles = makeStyles((theme) => ({
//     root: {
//         height: "auto",
//         marginTop: 20,
//         maxHeight: 600,
//         maxWidth: 900,
//         paddingTop: 20,
//         borderRadius: 5,
//         boxShadow: "0px 3px 15px #BCB0B0",
//         background: "#EEEEEE",
//         display: "flex",
//         justifyContent: "space-evenly",
//     },
// }));

const styles = {
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },
    textFieldBox: {
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        marginBottom: "25px",
    },
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },
};

const theme = createTheme();

function EditUser() {

    const location = useLocation();

    let initialState = location.state;
    // initialState.userType = location.state.app.userType;
    // console.log("data", location.state);

    // console.log("initialstate", initialState);
    const [input, setInput] = useState(initialState);
    const [searchedVal, setSearchedVal] = useState("");
    const [loader, setLoader] = useState(false);
    const ls = new SecureLS();
    let navigate = useNavigate();
    const userType = ls.get("userType")
    // console.log("userType>>", userType);
    // useEffect(() => {
    //     (async () => {

    //         let authenticated = await checkAuth();
    //         if (!authenticated) navigate("/Login");

    //     })();
    // }, []);

    function handleChange(event) {
        const { name, value } = event.target;

        setInput({
            ...input,
            [name]: value,
        });
        // console.log(input);
    }
    function handleUserTypeChange(event) {
        const { name, value } = event.target;

        setInput({
            ...input,
            app: {
                [name]: value,
            },
        });
        // console.log(input);
    }
    //   -----------------------SubmitHandler---------------------

    // console.log("sebi side edit called", input);


    const handleSubmit = (input) => {



        swal("Are you sure you want to update?", {

            buttons: ["Cancel", "Update"],
        }).then(result => {
            setLoader(true);
            if (result) {
                console.log("input.....edit",input)
                let encryptedayload = encrypt(input)
                sendRequest("api/update/updateUserDetails", { payload: encryptedayload })
                    .then((response) => {
                        // console.log(response);
                        if (response.type === "success") {

                            swal("Done", "User details are updated", "success");
                            setLoader(false);
                            navigate("/Manageuser");

                        } else {
                            setLoader(false);
                            swal("", response.message, "error");
                        }
                    })
                    .catch((error) => {
                        if(error){
                            swal("", error, "warning");
                            setLoader(false);
                        }
                        else{
                            swal("", "Something went wrong", "error");
                            setLoader(false);
                        }
                    });
            } else {
                setLoader(false)
            }

        });

    };

    function validateFields(login) {
        let alerted = false;
        let validEmail = validators.validateEmail(login.email);
        if (!validEmail.isValid && alerted === false) {
            alert(validEmail.message);
            alerted = true;
        }

        let validPhone = validators.validatePhoneNumber(login.mobile);
        if (!validPhone.isValid && alerted === false) {
            alert(validPhone.message);
            alerted = true;
        }
        return (
            login.firstName &&
            login.lastName &&
            validEmail.isValid &&
            validPhone.isValid
        );
    }

    // const cardStyles = useStyles(theme);

    return (
        <ThemeProvider theme={theme}>
            <Navbar />
            <Loader visible={loader} />
            {/* <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        onClick={() => navigate("/Manageuser")}
                        sx={{
                            bgcolor: "#EEEEEE",
                            mt: 1,
                            width: "300px",
                            borderRadius: 0,
                            height: 30,
                            fontFamily: "Roboto-Bold",
                            fontSize: "18px",
                            lineHeight: "23px",
                            display: "flex",
                            align: "center",
                            color: "#4343439e",
                            "&:hover": { backgroundColor: "#272782", color: "white" }
                        }}
                    >
                        <span
                            style={{
                                padding: "0 0 0 0",
                                fontSize: 14,
                                fontWeight: 600,
                            }}
                        >
                            Back to main page{"   "}
                        </span>
                    </Button>
                </Box> */}
            <Container
                theme={theme}
                component="main"
                maxWidth="lg"
                sx={{
                    //bgcolor:'red',
                    // marginTop: "30px",
                    // width: "60%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: "70%",
                    justifyContent: "center"

                }}
            >


                {/* <Card className={cardStyles.root}>
                    <Box sx={{ marginY: "20px", width: "100%" }}>
                        <Box component="form">
                            <Box sx={styles.rowContainer}>
                                <Box sx={styles.textFieldBox}>
                                    <p style={{ margin: "0px" }}>FIRST NAME</p>
                                    <TextField
                                        variant="standard"
                                        name="firstName"
                                        type="text"
                                        placeholder="Enter first name"
                                        value={input.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                </Box>
                                <Box sx={styles.textFieldBox}>
                                    <p style={{ margin: "0px" }}>LAST NAME</p>
                                    <TextField
                                        variant="standard"
                                        name="lastName"
                                        type="text"
                                        placeholder="Enter last name"
                                        value={input.lastName}
                                        onChange={handleChange}
                                        required
                                        sx={{}}
                                    />
                                </Box>

                            </Box>
                            <Box sx={styles.rowContainer}>
                                <Box sx={styles.textFieldBox}>

                                    <p style={{ margin: "0px", color: "#999999" }}>EMAIL - ID</p>
                                    <TextField
                                        disabled
                                        variant="standard"
                                        name="email"
                                        type="email"
                                        placeholder="Enter email id"
                                        value={input.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </Box>
                                <Box sx={styles.textFieldBox}>
                                    <p style={{ margin: "0px", color: "#a49999" }}>USER TYPE</p>
                                    <FormControl
                                        variant="standard"
                                        sx={{ my: 0, width: 280, minWidth: 120 }}
                                    >
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            name="userType"
                                            disabled
                                            value={input.app.userType}
                                            onChange={handleUserTypeChange}
                                            label="User Type"
                                            placeholder="Select user type"
                                            sx={{}}
                                        >
                                            <MenuItem value="PMS">AMC</MenuItem>
                                            <MenuItem value="SEBIUSER">SEBIUSER</MenuItem>
                                            <MenuItem value="APMII">APMII</MenuItem>
                                            <MenuItem value="ADMIN">ADMIN</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>

                            <Box sx={styles.rowContainer}>
                                <Box sx={styles.textFieldBox}>
                                    <p style={{ margin: "0px" }}>MOBILE NUMBER</p>
                                    <TextField
                                        variant="standard"
                                        name="mobile"
                                        type="tel"
                                        placeholder="Enter mobile number"
                                        value={input.mobile}
                                        onChange={handleChange}
                                        required
                                        sx={{}}
                                    />
                                    <div id="error-mobile-number"></div>
                                </Box>
                                <Box sx={styles.textFieldBox}>
                                    <p style={{ margin: "0px" }}>STATUS</p>
                                    <FormControl
                                        variant="standard"
                                        sx={{ my: 0, width: 280, minWidth: 120 }}
                                    >
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            name="accountStatus"
                                            value={input.accountStatus}
                                            onChange={handleChange}
                                            label="status"
                                            placeholder="Select user status"
                                            sx={{}}
                                        >
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Decommissioned">Decommissioned</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        bgcolor: "#272782",
                                        mt: 1,
                                        width: "150px",
                                        borderRadius: 0,
                                        height: 40,
                                        fontFamily: "Roboto-Light",
                                        fontSize: "18px",
                                        lineHeight: "23px",
                                        display: "flex",
                                        align: "center",
                                        color: "#FFFFFF",
                                    }}
                                >
                                    <span
                                        style={{
                                            padding: "0 0 0 0",
                                            fontSize: 14,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Update{"   "}
                                    </span>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Card> */}
                {userType == "PMS" &&
                    <AMCReg
                        userDetails={input}
                        handleUpdate={handleSubmit} />
                }
                {userType == "APMII" &&
                    <Rtareg
                        userDetails={input}
                        handleUpdate={handleSubmit} />
                }
                {userType == "SEBI" &&
                    <Sebi_Registration
                        userDetails={input}
                        handleUpdate={handleSubmit} />
                }
            </Container>
        </ThemeProvider>
    );
}

export default EditUser;